import { useState, useEffect } from 'react';
import { DriversService } from '../services/drivers.service';
import { Driver, CreateDriverDto, UpdateDriverDto } from '../types/driver.types';

interface UseDriversReturn {
  drivers: Driver[];
  loading: boolean;
  error: Error | null;
  createDriver: (data: CreateDriverDto) => Promise<void>;
  updateDriver: (id: string, data: UpdateDriverDto) => Promise<void>;
}

export const useDrivers = (): UseDriversReturn => {
  const [drivers, setDrivers] = useState<Driver[]>([]);
  const [loading, setLoading] = useState<boolean>(true);
  const [error, setError] = useState<Error | null>(null);

  useEffect(() => {
    setLoading(true);
    const unsubscribe = DriversService.subscribeToDrivers((data) => {
      setDrivers(data);
      setLoading(false);
    });

    return () => unsubscribe();
  }, []);

  const createDriver = async (data: CreateDriverDto): Promise<void> => {
    try {
      await DriversService.createDriver(data);
    } catch (err) {
      setError(err as Error);
      throw err;
    }
  };

  const updateDriver = async (id: string, data: UpdateDriverDto): Promise<void> => {
    try {
      await DriversService.updateDriver(id, data);
    } catch (err) {
      setError(err as Error);
      throw err;
    }
  };

  return {
    drivers,
    loading,
    error,
    createDriver,
    updateDriver
  };
};